import { Link } from "react-router-dom";
import "./Footer.css";
import { useAuth } from "../../contexts/AuthContext";

const Footer = () => {
  const { user } = useAuth();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>
          <p className="site-footer__title">Heliocentric Astrology</p>
          <p className="site-footer__text">
            Translating heliocentric dynamics into concise, soul-level insights.
          </p>
        </div>
        <div className="site-footer__links">
          <Link to="/app">Astrology App</Link>
          {!user && <Link to="/login">Login</Link>}
          {!user && <Link to="/signup">Sign Up</Link>}
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms &amp; Conditions</Link>
        </div>
      </div>
      <p className="site-footer__note">
        © Heliocentric Astro. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;

